import { useQuery } from "@tanstack/react-query";
import {
  PanelSearchParams,
  panelSearch,
} from "common/api/sakusas/sakusas_panel";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasPanelSearch = (searchParams?: PanelSearchParams) => {
  const { data: panel } = useQuery(
    [QUERY_KEYS.SAKUSAS_PANEL_SEARCH, searchParams],
    async () => {
      const result = await panelSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof panel !== "undefined" && panel !== "" ? panel : null;
  return result;
};
